import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDR1ApOHTwOJRMdl_SqbQnSIxbxcH4G1Rw",
  authDomain: "cupdate-ececc.firebaseapp.com",
  projectId: "cupdate-ececc",
  storageBucket: "cupdate-ececc.firebasestorage.app",
  messagingSenderId: "962700864883",
  appId: "1:962700864883:web:605ba7f0abad9a2353e906",
  measurementId: "G-50YKJWSTSN"
};

let app, auth, db, storage, functions;

try {
  // Initialize Firebase
  app = initializeApp(firebaseConfig);

  // Firebase Authentication service
  auth = getAuth(app);

  // Firebase Firestore service
  db = getFirestore(app);

  // Firebase Storage service
  storage = getStorage(app);

  // Firebase Functions service: europe-west4 per eis
  functions = getFunctions(app, "europe-west4");
} catch (error) {
  console.error('Firebase initialization error:', error);
  throw error;
}

export { auth, db, storage, functions }; 